import * as React from 'react';
import { inject, injectable } from 'inversify';

import { Button, notification } from 'antd';

type ToastType = 'success' | 'error' | 'info' | 'warning';

/**
 * ToastNotifications class
 */
@injectable()
export class ToastNotifications {

	/**
	 * Constructor
	 */
	constructor() {
		// nothing...
	}

	/**
	 * Show Toast
	 * @param title
	 * @param ok
	 */
    public showToast(title: string | React.ReactNode, description: string | React.ReactNode, type: ToastType, duration = null) {
        const defaultDuration = 5;
        let msg: any = description;
		if (Array.isArray(description)) {
			msg = description.map((t, i) => <div key={i}>{t}</div>);
		}
		else {
			try {
				msg = <div dangerouslySetInnerHTML={{ __html: description as string }}></div>
			}
			catch (e) {
				console.log(e);
			}
		}
        switch (type) {
            case 'success':
                console.log(title, msg);
                notification.success({
                    message: title,
                    description: msg,
                    duration: duration || defaultDuration
                });
                break;
            case 'error':
                console.error(title, msg);
                notification.error({
                    message: title,
                    description: msg,
                    duration: duration
                });
                break;
            case 'info':
                console.info(title, msg);
                notification.info({
                    message: title,
                    description: msg,
                    duration: duration || defaultDuration
                });
                break;
            case 'warning':
                console.warn(title, msg);
                notification.warning({
                    message: title,
                    description: msg,
                    duration: duration || defaultDuration
                });
                break;
            default:
                throw Error('Not supported type: ' + type);
        }
    }

	/**
	 * Show Text when save data
	 */
	showDataSaved() {
		this.showToast('Data Saved!', null, 'success');
	}
}



// WEBPACK FOOTER //
// ./src/core/ui/toast.tsx